import React, {Component} from "react";
import {connect} from "react-redux";
import {getHistory} from "../../redux/actions/bet";

class UserResultFilter extends Component {
	state = {
		period : 0
	};

	componentWillMount() {
		this.props.onGetHistory(this.state.period);
	}

	changePeriod(e) {
		this.setState({
			period : e.target.value
		}, () => {
			this.props.onGetHistory(this.state.period)
		});
	}

	render() {
		return (
			<div className="result">
				<div className="result__filter">
					<select className="result__filter-calendar" onChange={this.changePeriod.bind(this)}>
						<option value="0">За последние 3 суток</option>
						<option value="1">За последнюю неделю</option>
						<option value="2">За последний месяц</option>
						{/*<option value="6">За текущий год</option>*/}
						{/*<option value="4">За 2017 год</option>*/}
						<option value="5">Неразыгранные ставки</option>
					</select>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		bet : state.bet
	}),
	dispatch => ({
		onGetHistory : (period) => {
			dispatch(getHistory(period));
		}
	})
)(UserResultFilter);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserResultFilter.js